import * as tslib_1 from "tslib";
import { Item } from './item';
import { Value } from './value';
var Extant = (function (_super) {
    tslib_1.__extends(Extant, _super);
    function Extant() {
        return _super.call(this) || this;
    }
    Extant.prototype.isDistinct = function () {
        return false;
    };
    Extant.prototype.not = function () {
        return Value.Absent;
    };
    Extant.prototype.stringValue = function () {
        return '';
    };
    Extant.prototype.booleanValue = function () {
        return true;
    };
    Extant.prototype.toAny = function () {
        return null;
    };
    Extant.prototype.valueOf = function () {
        return null;
    };
    Extant.prototype.writeRecon = function (output) {
    };
    Extant.prototype.toRecon = function () {
        return '';
    };
    Extant.prototype.toReconBlock = function () {
        return '';
    };
    Extant.prototype.compare = function (that) {
        if (that instanceof Extant) {
            return 0;
        }
        else if (that === Value.Absent) {
            return -1;
        }
        else {
            return 1;
        }
    };
    Extant.prototype.equals = function (that) {
        return this === that;
    };
    Extant.prototype.hashCode = function () {
        return 0xF69C1707;
    };
    Extant.prototype.toString = function () {
        return 'extant';
    };
    return Extant;
}(Value));
export { Extant };
Item.Extant = new Extant();
Value.Extant = Item.Extant;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0YW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZXh0YW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQUMsSUFBSSxFQUFDLE1BQU0sUUFBUSxDQUFDO0FBQzVCLE9BQU8sRUFBVyxLQUFLLEVBQUMsTUFBTSxTQUFTLENBQUM7QUFHeEM7SUFBNEIsa0NBQUs7SUFFL0I7ZUFDRSxpQkFBTztJQUNULENBQUM7SUFFRCwyQkFBVSxHQUFWO1FBQ0UsTUFBTSxDQUFDLEtBQUssQ0FBQztJQUNmLENBQUM7SUFFRCxvQkFBRyxHQUFIO1FBQ0UsTUFBTSxDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUM7SUFDdEIsQ0FBQztJQUVELDRCQUFXLEdBQVg7UUFDRSxNQUFNLENBQUMsRUFBRSxDQUFDO0lBQ1osQ0FBQztJQUVELDZCQUFZLEdBQVo7UUFDRSxNQUFNLENBQUMsSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUVELHNCQUFLLEdBQUw7UUFDRSxNQUFNLENBQUMsSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUVELHdCQUFPLEdBQVA7UUFDRSxNQUFNLENBQUMsSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUVELDJCQUFVLEdBQVYsVUFBVyxNQUFtQjtJQUU5QixDQUFDO0lBRUQsd0JBQU8sR0FBUDtRQUNFLE1BQU0sQ0FBQyxFQUFFLENBQUM7SUFDWixDQUFDO0lBRUQsNkJBQVksR0FBWjtRQUNFLE1BQU0sQ0FBQyxFQUFFLENBQUM7SUFDWixDQUFDO0lBRUQsd0JBQU8sR0FBUCxVQUFRLElBQVU7UUFDaEIsRUFBRSxDQUFDLENBQUMsSUFBSSxZQUFZLE1BQU0sQ0FBQyxDQUFDLENBQUM7WUFDM0IsTUFBTSxDQUFDLENBQUMsQ0FBQztRQUNYLENBQUM7UUFBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUMsSUFBSSxLQUFLLEtBQUssQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDO1lBQ2pDLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUNaLENBQUM7UUFBQyxJQUFJLENBQUMsQ0FBQztZQUNOLE1BQU0sQ0FBQyxDQUFDLENBQUM7UUFDWCxDQUFDO0lBQ0gsQ0FBQztJQUVELHVCQUFNLEdBQU4sVUFBTyxJQUFTO1FBQ2QsTUFBTSxDQUFDLElBQUksS0FBSyxJQUFJLENBQUM7SUFDdkIsQ0FBQztJQUVELHlCQUFRLEdBQVI7UUFDRSxNQUFNLENBQUMsVUFBVSxDQUFDO0lBQ3BCLENBQUM7SUFFRCx5QkFBUSxHQUFSO1FBQ0UsTUFBTSxDQUFDLFFBQVEsQ0FBQztJQUNsQixDQUFDO0lBQ0gsYUFBQztBQUFELENBQUMsQUEvREQsQ0FBNEIsS0FBSyxHQStEaEM7O0FBQ0EsSUFBWSxDQUFDLE1BQU0sR0FBRyxJQUFJLE1BQU0sRUFBRSxDQUFDO0FBQ25DLEtBQWEsQ0FBQyxNQUFNLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyJ9